<template lang="pug">
.divider
  .divider-content
    Divider 分割线
    iDelModel(:del-model='delModel',@upData="$emit('upData')",@downData="$emit('downData')")
</template>

<script>
import iDelModel from "@/components/common/iDelModel";
export default {
  components: {
    iDelModel
  },
  methods: {
    delModel() {
      this.$emit("delModel");
    }
  }
};
</script>

<style lang="stylus">
.divider
  width 100%
  padding 24px 100px 24px 0px
  background:rgba(248,249,250,1);
  border-radius:4px;
  border:1px dashed rgba(128,128,128,0.5);
  .divider-content
    position relative
    .idelModel
      position: absolute;
      top: 0px;
      right: -50px;
    .ivu-form-item-content
      width 75%
</style>
